import { createFileRoute } from '@tanstack/react-router';

import { PricingPage } from '@/features/marketing/pages/pricing';
import { destinationSearch } from '@/utils/destination-search';

export const Route = createFileRoute('/pricing')({
	// Порт призначення, до якого рахує вітрина (`?to=`).
	validateSearch: destinationSearch,
	component: PricingPage,
});
